

<template>
  <div class="nav-bar">
    <ul class="nav-list">
      <router-link tag="li" class="nav-list-item active" to="home">
        <i class="nbicon nblvsefenkaicankaoxianban-1"></i>
        <span>{{ $t("header.home") }}</span>
      </router-link>
      <router-link tag="li" class="nav-list-item" to="product">
        <i class="nbicon nbfenlei"></i>
        <span>{{ $t("header.product") }}</span>
      </router-link>
      <router-link tag="li" class="nav-list-item" to="video">
        <van-icon  name="shopping-cart-o" :info="!count ? '' : count" />
        <span>{{ $t("header.video") }}</span>
      </router-link>
      <router-link tag="li" class="nav-list-item" to="about">
        <i class="nbicon nblvsefenkaicankaoxianban-"></i>
        <span>{{ $t("header.about") }}</span>
      </router-link>
    </ul>
  </div>
</template>

<script>
  import { getLocal } from '../js/utils'
  export default {
    mounted() {
      const token = getLocal('token')
      const path = this.$route.path
      if (token && path != '/home') {
        this.$store.dispatch('updateCart')
      }
    },
    data() {
      return {}
    },
    computed: {
      count () {
        // this.$store.state.cartCount
        return 0 
      }
    }
  }
</script>

<style lang="less" scoped >
    @import '../style/mixin';
    .nav-bar{
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      padding: 5px 0;
      z-index: 1000;
      background: #fff;
      transform: translateZ(0);
      -webkit-transform: translateZ(0);
      .nav-list {
        width: 100%;
        .fj();
        flex-direction: row;
        padding: 0;
        .nav-list-item {
          display: flex;
          flex: 1;
          flex-direction: column;
          text-align: center;
          color: #666;
          &.router-link-active {
            color: @primary;
          }
          i {
            text-align: center;
            font-size: 22px;
          }
          span{
            font-size: 12px;
          }
          .van-icon-shopping-cart-o {
            margin: 0 auto;
            margin-bottom: 2px;
          }
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue